var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickUnCheckSquare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.25H9C6.57397 21.25 5.07086 20.7602 4.15533 19.8447C3.2398 18.9291 2.75 17.426 2.75 15V9C2.75 6.57397 3.2398 5.07086 4.15533 4.15533C5.07086 3.2398 6.57397 2.75 9 2.75H15C17.426 2.75 18.9291 3.2398 19.8447 4.15533C20.7602 5.07086 21.25 6.57397 21.25 9V15C21.25 17.426 20.7602 18.9291 19.8447 19.8447C18.9291 20.7602 17.426 21.25 15 21.25Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickUnCheckSquare);
export default __webpack_public_path__ + "static/media/tick-unCheck-square.ddc984f8489d02626c8bd43569c253ac.svg";
export { ForwardRef as ReactComponent };